import React from 'react'
import PropTypes from 'prop-types'
import { nl2br } from 'supports/text_format_react_helper'

const Paragraph = ({ className, children }) => <p className={className}>{nl2br(children)}</p>

Paragraph.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string.isRequired
}

Paragraph.defaultProps = {
  className: null
}

export default Paragraph
